<template lang="pug">
  div(class="history-item" v-waypoint="{active: true, callback: onWaypoint}")
    div(class="history-item-content")
      div(class="history-item-content-inner")
        div(class="history-item-year")
          span {{ item.year }}
        div(class="history-item-title")
          span {{ item.title }}
        div(class="history-item-description")
          p(v-for="(line, index) in item.content") {{ line }}
      div(class="history-item-placeholder")
    div(class="history-item-image")
      img(:src="item.image")
</template>

<script>
export default {
  name: 'history-item',
  props: ['item'],
  methods: {
    onWaypoint (payload) {
      if (payload.direction && payload.going === 'in') {
        console.log(payload, this.$vnode.key)
        this.$emit('waypoint', this.$vnode.key)
      }
    }
  }
}
</script>

<style lang="stylus">
.history-item
  flex: 0 0 auto
  position: relative
  display: flex;
  min-width: 100vw
  &-content
    height: 100%
    width: 50em
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding-top: 8em
    @media (max-height: 800px)
      padding-top: 6em
    &-inner
      text-align: center;
      max-width: 40em
      margin-bottom: 65em
      @media (max-height: 1000px)
        font-size: 1.4vh
  &-title
    text-transform: uppercase;
    font-size: 1.2em
    & span
      letter-spacing: 0.15em
  &-year
    font-size: 5em
    transition: all 300ms ease
    @media (max-height: 900px)
      font-size: 4em
    &:before
    &:after
      content: '-'
    & > span
      letter-spacing: 0.1em
  &-placeholder
    height: 40em
    width: 40em
    border: 1em solid
    position: absolute;
    bottom: 5em
    opacity: 0
  &-image
    flex: 0 0 auto
    & > img
      height: 100%
      width: auto
</style>



// WEBPACK FOOTER //
// src/components/history-item.vue